import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RcsSupplierInfoTable from './RcsSupplierInfoTable';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component.jsx';


import './RcsSupplierInfoDialog.custom.scss';

const spinnerId = 'id';

export default function RcsSupplierInfoDialog (props) {
  const { supplierInfo } = props;

  const spinnerOrTable = !supplierInfo ? (
      <RxSpinnerComponent
        spinnerScale={1}
        autoStart
        spinnerId={spinnerId}
      />
    ) :
    (
      <RcsSupplierInfoTable {...props} />
    );

  return (
    <GeneralDialogLayout
      {...props}
      size='lg'
      headerClassName='rcs-supplier-info--header'
      contentClassName='rcs-supplier-info--content'
      header={
        <h4 className='rcs-supplier-info--header-text'>Supplier information</h4>
      }
      footer={null}
    >
      {spinnerOrTable}
    </GeneralDialogLayout>
  );
}

RcsSupplierInfoDialog.propTypes = {
  supplierInfo: PropTypes.instanceOf(Map),
};
